// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fy-j";
export var fulfillmentFormRail = "_fy-i";
export var headerTitleRow = "_fy-l";
export var orderDetailsWrapper = "_fy-g";
export var orderLinkTrigger = "_fy-2";
export var paymentInformationGrid = "_fy-q";
export var paymentSummaryColumn = "_fy-r";
export var phoneShipmentPickerButton = "_fy-e";
export var phoneShipmentPickerButtonContent = "_fy-f";
export var phoneShipmentPickerButtonWrapper = "_fy-d";
export var phoneShipmentPickerTrigger = "_fy-c";
export var shipmentContainer = "_fy-k";
export var shipmentDetailsMainPane = "_fy-h";
export var shipmentNavigationCard = "_fy-a";
export var shipmentNavigationEdgeTrigger = "_fy-6";
export var shipmentNavigationRail = "_fy-3";
export var shipmentNavigationRailEnter = "_fy-5";
export var shipmentNavigationRailHeader = "_fy-9";
export var shipmentNavigationRailOverlay = "_fy-4";
export var shipmentNavigationScrim = "_fy-7";
export var shipmentSummaryFact = "_fy-n";
export var shipmentSummaryGrid = "_fy-m";
export var shipmentSummaryMetadataRow = "_fy-o";
export var shipmentSummaryTags = "_fy-p";
export var shipmentWorkspace = "_fy-0";
export var shipmentWorkspaceBodyTablet = "_fy-8";
export var shipmentWorkspaceContent = "_fy-b";
export var shipmentWorkspaceHeader = "_fy-1";